export default {
  bind(el) {
    let isComposing = false;
    let lastValidValue = '';

    // 处理输入事件
    el.handler = function (event) {
      if (isComposing) return;

      let value = event.target.value;

      // 移除所有非数字和小数点的字符
      value = value.replace(/[^\d.]/g, '');

      // 确保只保留一个小数点
      const parts = value.split('.');
      if (parts.length > 2) {
        value = parts[0] + '.' + parts.slice(1).join('');
      }

      // 保留小数点后两位
      if (parts[1]) {
        parts[1] = parts[1].slice(0, 2);
        value = parts.join('.');
      }

      // 检查值是否符合正则表达式
      const regex = /^\d*\.?\d{0,2}$/;
      if (regex.test(value)) {
        // 如果值合法，则更新 lastValidValue
        lastValidValue = value;
        // 设置输入框的值
        event.target.value = value;
        // 手动触发 input 事件以便更新 v-model 绑定的值
        setTimeout(() => {
          const inputEvent = new Event('input', { bubbles: true });
          event.target.dispatchEvent(inputEvent);
        });
      } else {
        // 如果值不合法，则恢复为上一次合法的值
        event.target.value = lastValidValue;
      }
    };

    // 处理输入法组合输入开始事件
    el.compositionStartHandler = function () {
      isComposing = true;
    };

    // 处理输入法组合输入结束事件
    el.compositionEndHandler = function (event) {
      isComposing = false;
      // 组合输入结束后，处理输入值
      el.handler(event);
    };

    // 绑定事件监听器
    el.addEventListener('input', el.handler);
    el.addEventListener('compositionstart', el.compositionStartHandler);
    el.addEventListener('compositionend', el.compositionEndHandler);
  },
  // 当指令从元素上解绑时
  unbind(el) {
    // 移除事件监听器
    el.removeEventListener('input', el.handler);
    el.removeEventListener('compositionstart', el.compositionStartHandler);
    el.removeEventListener('compositionend', el.compositionEndHandler);
  }
};
